export default __webpack_public_path__ + "static/media/wafer-bg-right-flat.872ab4e5.png";